/**
 * RxDB Bundle
 * Contains only RxDB and its plugins for standalone usage
 */

// Polyfill for crypto.subtle in non-HTTPS contexts (development only)
if (typeof window !== 'undefined' && !window.crypto?.subtle) {
  console.warn('[RxDB Bundle] crypto.subtle not available - using polyfill for development');
  if (!window.crypto) {
    window.crypto = {};
  }
  window.crypto.subtle = {
    digest: async (algorithm, data) => {
      // Simple hash implementation for development only
      const hashHex = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const arr = new Uint8Array(reader.result);
          const hash = Array.from(arr).map(b => b.toString(16).padStart(2, '0')).join('');
          resolve(hash);
        };
        reader.readAsArrayBuffer(new Blob([data]));
      });
      // Convert hex string to ArrayBuffer
      const bytes = new Uint8Array(hashHex.length / 2);
      for (let i = 0; i < bytes.length; i++) {
        bytes[i] = parseInt(hashHex.substr(i * 2, 2), 16);
      }
      return bytes.buffer;
    }
  };
}

// RxDB core exports
export * from 'rxdb';

// RxDB plugins
export { RxDBDevModePlugin } from 'rxdb/plugins/dev-mode';
export { RxDBQueryBuilderPlugin } from 'rxdb/plugins/query-builder';
export { getRxStorageMemory } from 'rxdb/plugins/storage-memory';
export { getRxStorageLocalstorage } from 'rxdb/plugins/storage-localstorage';
export { getRxStorageDexie } from 'rxdb/plugins/storage-dexie';
export { wrappedValidateAjvStorage, getAjv } from 'rxdb/plugins/validate-ajv';
export { replicateRxCollection } from 'rxdb/plugins/replication';
export { replicateSupabase } from 'rxdb/plugins/replication-supabase';
export { RxDBLeaderElectionPlugin } from 'rxdb/plugins/leader-election';
export { RxDBMigrationSchemaPlugin } from 'rxdb/plugins/migration-schema';
export { RxDBStatePlugin } from 'rxdb/plugins/state';
export {
  RxDBCleanupPlugin,
  DEFAULT_CLEANUP_POLICY,
} from 'rxdb/plugins/cleanup';

// Note: ajv-formats are already included in wrappedValidateAjvStorage
// No need to export addFormats separately